import type { ApiVolopImportedType } from '#/modules/listing/volops/api/types/ApiVolopImportedType';

export const VOLOP_IMPORTED_TYPE_MAP: Record<ApiVolopImportedType, string> = {
  GOLDEN: 'Golden',
};
